import React from 'react';
import styles from './NoData.module.scss';

const NoData = (): JSX.Element => {
	return (
		<div className={styles.NoData}>
			<p>No Data</p>
		</div>
	);
};

export default NoData;
